/* src/app/location-users/add-location-users/add-user-form/add-user-form.component.scss */
.add-user-form {
  border: solid 1px #6E6E6E;
  width: 922px;
  margin-top: 16px;
}
form {
  padding: 1rem 2rem 4px;
  width: max-content;
}
form .form-row {
  gap: 16px;
}
form label {
  font-weight: bold;
}
form label:has(~ .error) {
  color: #C91913;
}
form button {
  margin-top: 28px;
  height: 36px;
  min-width: 168px;
  background-color: #00857D;
  border-radius: 100px;
  color: white;
  border: 0;
  margin-left: 16px;
  white-space: nowrap;
}
form button:disabled {
  background-color: #E8E8E6 !important;
  color: #BEBEBE !important;
  border: none !important;
}
form .upsid {
  width: 240px;
  padding-right: 2rem;
}
form .email {
  width: 402px;
  position: relative;
}
form .email > input {
  padding-right: 2rem;
}
form .role ::ng-deep select {
  width: 200px;
}
form .search {
  width: 658px;
}
form .search ::ng-deep input {
  border-color: #979797 !important;
  border-radius: 0.25rem !important;
}
form .error {
  border-color: #C91913 !important;
  border-width: 2px !important;
  position: relative;
}
form .error-icon::after {
  font-family: "upsicons", fantasy !important;
  content: "\e638" !important;
  color: #C91913;
  position: absolute;
  font-size: 16px;
  bottom: 2.7rem;
  right: 1rem;
}
.locations {
  border-top: 1px solid #BEBEBE;
  height: 107px;
  color: #404040;
  font-size: 14px;
  padding-top: 14px;
  padding-bottom: 14px;
  padding-left: 95px;
  padding-right: 20px;
  overflow: auto;
}
.locations .location {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 5px;
  line-height: 1.85em;
}
.locations .ups-icon-x {
  cursor: pointer;
  color: #426DA9;
}
/*# sourceMappingURL=add-user-form.component.css.map */
